import { CheckCircle2, XCircle, Clock, AlertTriangle, ShieldCheck, RotateCcw, Circle } from "lucide-react";

const RISK_LABEL = { faible: "Faible", moyen: "Moyen", eleve: "Élevé" };

export default function QualityGatePanel({ gates, currentStep, onGoTo, synthese, validatedSteps = [], toReview = [] }) {
  if (!gates || !gates.length) return null;

  // 4 états : à revoir > validée > en cours > à renseigner
  const stateOf = (g) => {
    if (toReview.includes(g.index)) return { key: "revoir", label: "À revoir", icon: <RotateCcw size={15} className="qg-ic rev" /> };
    if (validatedSteps.includes(g.index) && g.statut === "conforme") return { key: "validee", label: "Validée", icon: <CheckCircle2 size={15} className="qg-ic ok" /> };
    if (g.index === currentStep) return { key: "encours", label: "En cours", icon: <Clock size={15} className="qg-ic cur" /> };
    if (g.statut !== "conforme") return { key: "arenseigner", label: "À renseigner", icon: <Circle size={13} className="qg-ic todo" /> };
    return { key: "arenseigner", label: "À renseigner", icon: <Circle size={13} className="qg-ic todo" /> };
  };

  return (
    <div className="card qg-panel" data-testid="quality-gate-panel" style={{ marginBottom: 14 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
        <ShieldCheck size={18} color="var(--sarcelle)" />
        <h3 style={{ fontSize: ".95rem", margin: 0 }}>Progression du dossier</h3>
      </div>
      <p style={{ fontSize: ".74rem", color: "var(--text-muted)", margin: "0 0 10px" }}>
        Vue d'ensemble du dossier jusqu'au démarrage : chaque étape doit être validée avant de poursuivre.
        <br /><em>Distinct de la préparation ci-dessus, qui ne concerne que la création de l'intervention.</em>
      </p>

      {synthese && (
        <div style={{ marginBottom: 12 }} data-testid="qg-synthese">
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: ".72rem", color: "var(--text-muted)", marginBottom: 4 }}>
            <span className="mono">{validatedSteps.length}/{synthese.gatesTotal} étapes validées</span>
            <span className="mono">Préparation {synthese.scoreGlobal}%</span>
          </div>
          <div style={{ height: 6, background: "var(--ligne)", borderRadius: 4, overflow: "hidden" }}>
            <div style={{ height: "100%", width: `${synthese.scoreGlobal}%`,
              background: synthese.scoreGlobal >= 100 ? "var(--vert)" : synthese.scoreGlobal >= 60 ? "var(--sarcelle)" : "var(--ambre)",
              transition: "width .3s" }} />
          </div>
          <div className="qg-summary" data-testid="qg-summary">
            <div className="qg-stat"><span className="v">{RISK_LABEL[synthese.niveauRisque] || "Faible"}</span><span className="l">Niveau de risque</span></div>
            <div className="qg-stat"><span className="v">{synthese.nbPermisRecommandes}</span><span className="l">Permis recommandés</span></div>
            <div className="qg-stat"><span className="v">{synthese.controlesObligatoiresValides}/{synthese.controlesObligatoiresTotal}</span><span className="l">Contrôles validés</span></div>
            <div className="qg-stat"><span className="v">{synthese.recommandations + (synthese.avertissements || 0)}</span><span className="l">Recommandations</span></div>
          </div>
        </div>
      )}

      <div className="qg-list">
        {gates.map((g) => {
          const st = stateOf(g);
          return (
            <button type="button" key={g.id} className={`qg-row st-${st.key} ${g.index === currentStep ? "on" : ""}`}
              onClick={() => onGoTo(g.index)} data-testid={`qg-row-${g.id}`} data-state={st.key}>
              {st.icon}
              <span className="qg-label">{g.label}</span>
              <span className="qg-state-lbl">{st.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
